import { render, staticRenderFns } from "./ratingScoreManagement.vue?vue&type=template&id=27ca9200&scoped=true"
import script from "./ratingScoreManagement.vue?vue&type=script&lang=js"
export * from "./ratingScoreManagement.vue?vue&type=script&lang=js"
import style0 from "./ratingScoreManagement.vue?vue&type=style&index=0&id=27ca9200&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca9200",
  null
  
)

export default component.exports